import React from 'react';

const Button = ({
  type = 'button',
  onClick,
  children,
  variant = 'primary',
  disabled,
  className = '',
  'data-testid': dataTestId = 'button',
  ...rest
}) => {

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${className}`}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
